import {useDispatch, useSelector} from 'Provider';
import React, {useCallback} from 'react';

import OfferFilters from 'components/Offers/Filters';
import {OfferType} from 'models/Offer';
import {
  OfferFiltersDestination,
  OfferFiltersProperty,
} from 'models/OfferFilters';
import {sortedMarketsSelector} from 'store/markets/markets.selectors';
import {OffersActions} from 'store/offers/offers.reducer';
import {
  availableFiltersSelector,
  selectedFilterSelector,
} from 'store/offers/offers.selectors';
import {sortedPropertiesSelector} from 'store/properties/properties.selectors';

const ConnectedOfferFilters: React.FC = () => {
  const dispatch = useDispatch();
  const markets = useSelector(sortedMarketsSelector);
  const properties = useSelector(sortedPropertiesSelector);
  const availableFilters = useSelector(availableFiltersSelector);
  const selectedFilters = useSelector(selectedFilterSelector);

  const setSelectedOfferTypes = useCallback(
    offerTypes =>
      dispatch(OffersActions.setSelectedOfferTypeFilter(offerTypes)),
    [dispatch]
  );
  const setSelectedDestination = useCallback(
    (destination: OfferFiltersDestination | undefined) => {
      dispatch(OffersActions.setSelectedDestinationFilter(destination));
    },
    [dispatch]
  );

  const setSelectedProperties = useCallback(
    (propertyList: OfferFiltersProperty[] | undefined) => {
      dispatch(OffersActions.setSelectedPropertyFilter(propertyList));
    },
    [dispatch]
  );

  const clearFilters = useCallback(
    () => dispatch(OffersActions.clearFilters()),
    [dispatch]
  );

  return (
    <OfferFilters
      markets={markets}
      properties={properties}
      setSelectedDestination={setSelectedDestination}
      setSelectedProperties={setSelectedProperties}
      selectedOfferTypes={selectedFilters.type ?? Object.values(OfferType)}
      setSelectedOfferTypes={setSelectedOfferTypes}
      availableFilters={availableFilters}
      clearFilters={clearFilters}
      selectedDestination={selectedFilters.destination}
      selectedProperties={selectedFilters.properties}
    />
  );
};

export default ConnectedOfferFilters;
